import React from 'react';

import styles from './footer.module.css';
import logo from '../../../assets/logo-sm.svg';

interface FooterProps {}

class Footer extends React.Component<FooterProps> {
    render() {
        return (
            <div className={styles.footer}>
                <a
                    href="https://intrena.co"
                    title="Ir a INTRENA"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={logo} alt="logo" />
                    <strong className={styles.branding}>&nbsp;INTRENA</strong>
                </a>
            </div>
        );
    }
}

export default Footer;
